<template>
  <form ref="form" :action="`${this.$runtimeConstants.SALESFORCE_ACCOUNT_REDIRECT_DOMAIN}/pro/login`" method="post">
    <input
        :value="formUsername"
        type="hidden"
        name="un">
    <input
        :value="formToken"
        type="hidden"
        name="pw">
    <input
        v-if="returnUrl"
        :value="returnUrl"
        type="hidden"
        name="retURL">
  </form>
</template>

<script>
import { mapGetters } from 'vuex';

import getUserAttributeValues from '@homeservices/api-kit/security/users/getUserAttributeValues';

const SOURCE_ENDPOINTS = {
  application_status: 'pro',
  feedback: 'pro/profeedback',
  workarea: 'pro/editworkarea',
  services: 'pro/editservices',
  expansion: 'pro/expansion',
  edit_profile: 'pro/editpersonalinformation',
};

let unwatch = null;

export default {
  name: 'auth-redirect-form',
  props: {
    source: {
      type: String,
      required: true,
      validator (value) {
        return Object.keys(SOURCE_ENDPOINTS).some(s => s === value) || value === '';
      },
    },
    occupId: {
      type: [String, Number],
      default: '',
    },
    token: {
      type: String,
      default: '',
    },
    username: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      formUsername: this.username,
      formToken: this.token,
    };
  },
  computed: {
    ...mapGetters('skeletonKey', ['authData']),
    ...mapGetters('user', ['isPro', 'userId']),
    accessToken () {
      return this.authData && this.authData.access_token;
    },
    returnUrl () {
      const { source } = this;
      if (!source) { return ''; }

      const { occupId } = this;
      const { hostname } = window.location;
      const baseReturnUrl = `${this.$runtimeConstants.SALESFORCE_ACCOUNT_REDIRECT_DOMAIN}/${SOURCE_ENDPOINTS[source]}?origDomain=${hostname}`;

      return occupId ? `${baseReturnUrl}&occupid=${occupId}` : baseReturnUrl;
    },
    canSubmit () {
      const { formUsername, formToken, returnUrl } = this;
      return Boolean(formUsername && formToken && returnUrl);
    },
  },
  methods: {
    async fetchData () {
      try {
        if (this.token) {
          await this.$store.dispatch('user/logoutAndClearUserSession');
          await this.$store.dispatch('user/loginUserWithAuthData', {
            access_token: this.token,
            token_type: 'Bearer',
            expires_in: 3600,
          });
        }
        const { access_token: accessToken } = this.authData;
        this.formToken = accessToken;
        const { data: { results } } = await getUserAttributeValues({ user_ids: this.userId });
        const salesforceAttr = results.find(result => result.user_attribute === 'salesforce_login');
        this.formUsername = salesforceAttr.user_attribute_value;
      } catch (error) {
        this.$events.$emit(this.$events.AUTH_REDIRECT_ERROR, {
          error,
          isPro: this.isPro,
          authData: this.authData,
        });
        this.$router.replace({ name: 'error' });
      }
    },
    submit () {
      this.fetchData();
      if (!unwatch) {
        // We have to check if form is ready to submit when user asks to submit the form.
        // canSubmit checks for parameters and returns true when they are ready.
        unwatch = this.$watch('canSubmit', {
          handler (value) {
            if (value) {
              this.$nextTick(() => {
                this.$refs.form.submit();
              });
            }
          },
          immediate: true,
        });
      }
    },
  },
};
</script>
